<template>
    <DndProvider :backend="HTML5Backend" :context="_WINDOW_">
        <transition-group name="list" tag="div">
            <selected-list-element
                v-for="(element) in inputItems"
                :element="element"
                :key="element.compound_id+'_g'+element.GroupId+'_'+element.compound_name"
                :input-index="element.Position"
                :parent-id="undefined"
                :parent-name="''"
                :parent-idx="element.compound_id+'_g'+element.GroupId+'_'+element.compound_name"
                :is-root="true"
                :allow-hover-action="allowHoverAction"
                :draggable="true"
                :grouping-mode="groupingMode"
                @changePosition="moveStoreItem"
                @changeSelection="onModelUpdate"
                @addToGroup="onAddToGroup(element.compound_id)"
                @removeFromGroup="onRemoveFromGroup(element.compound_id)"
                @togglesChange="onTogglesChange"
                @rangeChange="onRangeChange"
                @unGroupClick="onUnGroupClick"
                @unGroupSingleClick="onUnGroupSingleClick"
                :scroll-viewport="scrollViewport"
            />
        </transition-group>
    </DndProvider>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue, Watch } from 'vue-facing-decorator';
import SelectedListElement from '@/components/common/settings-list/SelectedListElement.vue';
import { DndProvider } from 'vue3-dnd';
import { ColumnSend, ColumnSendSelectable } from '@/models/interfaces/entity-settings/columns/columns';
import { BaseItemTypes } from '@/components/dnd/ItemTypes';

@Component({
  name: 'SelectedSettingsList',
  components: { SelectedListElement, DndProvider }
})
export default class SelectedSettingsList extends Vue {
    @Prop({ default: [] as ColumnSend[] })
    inputItems!: ColumnSend[]
    @Prop({ default: false })
    groupingMode?: boolean
    @Prop({ default: undefined })
    scrollViewport?: any

    compoind_ids: string[] = []

    @Emit("changePosition") emitMoveItem(arg: any) { return arg; }
    @Emit("changeSelection") emitSelectionChanged(arg: any) { return arg }
    @Emit("groupChange") emitGroupChange(arg: any) { return arg }
    @Emit("togglesChange") emitTogglesChange(arg: any) { return arg }
    @Emit("rangeChange") emitRangeChange(arg: any) { return arg }
    @Emit("unGroupClick") emitUngroupClick(arg: any) { return arg }
    @Emit("unGroupSingleClick") emitUngroupSingleClick(arg: any) { return arg }
    
    // temporary data
    HTML5Backend = require('react-dnd-html5-backend').HTML5Backend
    _WINDOW_ = window

    created() {
        //
    }

    onUnGroupClick(arg: any) {
      this.emitUngroupClick(arg)
    }

    onUnGroupSingleClick(arg: any) {
        this.emitUngroupSingleClick(arg)
    }

    onAddToGroup(val: string) {
        this.compoind_ids.push(val);
        (this.compoind_ids && this.compoind_ids.length) && (this.emitGroupChange(this.compoind_ids))
    }

    onRemoveFromGroup(val: string) {
        const found_index = this.compoind_ids.findIndex((el: string) => el == val)
        found_index >= 0 && this.compoind_ids.splice(found_index, 1);
        (this.compoind_ids && this.compoind_ids.length) && (this.emitGroupChange(this.compoind_ids))
    }

    onTogglesChange(arg: any) {
      this.emitTogglesChange(arg)
    }

    onRangeChange(arg: any) {
        this.emitRangeChange(arg)
    }

    onModelUpdate(arg: any) {
      this.emitSelectionChanged(arg)
    }

    allowHoverAction = (dragParams: any, hoverParams: any) => {
        // reorder on hover between root items of one type only (selections or projections)!
        return dragParams.callbackParams.elType === BaseItemTypes.SELECTED_COLUMN && 
            hoverParams.callbackParams.elType === BaseItemTypes.SELECTED_COLUMN 
    }

    // https request
    async moveStoreItem(params: any) {
        console.log('selected columns reorder')
        console.log(params)
        this.emitMoveItem(params)
    }
}
</script>